import TextInput from "../TextInput";
import { InputAdornment } from "@mui/material";

import { useEffect, useState } from "react";

export default function IconInput(props: any) {
  const {
    startComponent,
    endComponent,
    onFocus,
    onBlur,
    value,
    autoFocus,
    ...other
  } = props;
  const [shrink, setShrink] = useState(!!value);
  const [focused, setFocused] = useState(!!autoFocus);

  const labelProps = {
    shrink,
    ...(startComponent && { sx: { ml: 4 } }),
  };

  const TextStyle = {
    ...(startComponent && {
      "& .MuiOutlinedInput-notchedOutline": {
        px: 5,
      },
    }),
  };

  const startProp = {
    ...(startComponent && {
      startAdornment: (
        <InputAdornment position="start">{startComponent}</InputAdornment>
      ),
    }),
  };

  const endProp = {
    ...(endComponent && {
      endAdornment: (
        <InputAdornment position="end">{endComponent}</InputAdornment>
      ),
    }),
  };

  function handleOnFocus(e: any) {
    setFocused(true);
    setShrink(true);
    if (onFocus) {
      onFocus(e);
    }
  }

  function handleOnBlur(e: any) {
    setFocused(false);
    setShrink(!!e.target.value);
    if (onBlur) {
      onBlur(e);
    }
  }

  useEffect(() => {
    setShrink(!!value || focused);
  }, [value]);

  return (
    <TextInput
      {...(autoFocus && { autoFocus: true })}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      InputLabelProps={labelProps}
      sx={TextStyle}
      InputProps={{
        ...startProp,
        ...endProp,
      }}
      value={value}
      {...other}
    />
  );
}
